import ImmutableModel from '../immutable.model';

/**
 * A job title retrieved from the backend.
 */
class JobTitle extends ImmutableModel {
  /**
   * @param {String} type
   * @param {String} name
   */
  constructor(
    type,
    name
  ) {
    super();

    this.type = type;
    this.name = name;
  }

  copy() {
    return new JobTitle(this.type, this.name);
  }
}

export default JobTitle;
